import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_1002 implements Validator {

	public static id = 'CTRL_1002';
	private message = 'error.ctr_1002';


	public LOG: LogService = new LogService(CTRL_1002);
	public formExtractorService: FormExtractorService = new FormExtractorService();


	validate(form: any, map) {


		// vérifier si la règle est applicable sur mon formulaire
		const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_1002.id + '_');


		if (rgs.length > 0) {
			for (const rg of rgs) {
				const ctrl = form.controls[rg];
				const critPondJusquauWithStepId = map.get(ctrl.value.rgCtrls.critPond);
				const critPondPCTJusquauWithStepId = map.get(ctrl.value.rgCtrls.critPondPCT);
    const critPondJusquauCtrl = form.controls[critPondJusquauWithStepId];
    const critPondPCTJusquauCtrl = form.controls[critPondPCTJusquauWithStepId];

				if (!Number.isInteger(critPondJusquauCtrl) || !Number.isInteger(critPondPCTJusquauCtrl)) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
			}
		}
	}
}
